import { render, staticRenderFns } from "./PartsBook.vue?vue&type=template&id=4d15807a&scoped=true"
import script from "./PartsBook.vue?vue&type=script&lang=ts"
export * from "./PartsBook.vue?vue&type=script&lang=ts"
import style0 from "./PartsBook.vue?vue&type=style&index=0&id=4d15807a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d15807a",
  null
  
)

export default component.exports